export function TopLeftBar({ seated, away, pendingCount, onOptions, onLeave, onAway, onTopUp }: {
  seated: boolean; away: boolean; pendingCount: number; onOptions: () => void; onLeave: () => void; onAway: () => void; onTopUp: () => void;
}) {
  return (
    <>
      <div className="wordmark">PINEAPPLE POKER</div>
      <div className="toolbar">
        <button type="button" className="tool-btn" onClick={onOptions}>
          <span className="tool-icon menu" aria-hidden="true" />
          {pendingCount > 0 && <span className="tool-badge">{pendingCount}</span>}
          OPTIONS
        </button>
        {seated && (
          <button type="button" className="tool-btn" onClick={onLeave}><span className="tool-icon exit" aria-hidden="true" />LEAVE SEAT</button>
        )}
        {seated && (   /* sit out from the next hand, or come back; hidden on phones (portrait.css), where the options popover carries it */
          <button type="button" className="tool-btn away" onClick={onAway}><span className={`tool-icon ${away ? 'back' : 'away'}`} aria-hidden="true" />{away ? "I'M BACK" : 'AWAY'}</button>
        )}
        {seated && (
          <button type="button" className="tool-btn" onClick={onTopUp}><span className="tool-icon chips" aria-hidden="true" />TOP UP</button>
        )}
      </div>
    </>
  );
}
